<template>
  <v-app>
    <v-system-bar class="d-print-none pt-3" height="30" app lights-out>
      <v-toolbar-items class="ml-5">
        <v-btn
          href="javascript:window.print()"
          class="title elevation-0 mr-2"
          color="grey darken-1"
          x-large
        >
          <v-icon>mdi-printer</v-icon>&nbsp; พิมพ์
        </v-btn>
        <v-btn
          @click.stop="Export2Doc('exportContent', 'word-content-1-4')"
          class="title elevation-0"
          color="grey darken-1"
          x-large
        >
          <v-icon>mdi-file-word</v-icon>&nbsp; Export to Word
        </v-btn>
      </v-toolbar-items>
    </v-system-bar>

    <div id="exportContent">
      <div class="page">
        <div class="">
          <!-- หน้าที่ 1 -->
          <div class="text-right text_j">
            สัญญาจ้างเลขที่
            <span class="dotted-underline">
              {{ government_employee.id_office }}-{{
                government_employee.id_position
              }}/{{ years }}</span
            >
          </div>

          <div class="text-right text_j">
            {{ government_employee.college_name }}
          </div>

          <div class="text-center bold16 text_j">สัญญาจ้างพนักงานราชการ</div>
          <div class="text-center bold16 text_j">
            สํานักงานคณะกรรมการการอาชีวศึกษา
          </div>

          <div class="div-indent text_j mt-5">
            <div class="div-indent text_j">
              สัญญาจ้างพนักงานราชการฉบับนี้ ทําขึ้น ณ
              สํานักงานคณะกรรมการการอาชีวศึกษา เมื่อวันที่
              <span class="dotted-underline"> 1 ตุลาคม 2568</span>
              ระหว่างสํานักงานคณะกรรมการการอาชีวศึกษา โดย<span
                class="dotted-underline"
              >
                {{ government_employee.user_director }}</span
              >

              ตําแหน่ง<span class="dotted-underline"
                >ผู้อำนวยการ{{ government_employee.user_firstname }}</span
              >

              ผู้แทน/ผู้รับมอบอํานาจตามคําสั่งสํานักงานคณะกรรมการการอาชีวศึกษา
              ที่ <span class="dotted-underline"> 1834/2567 </span> ลงวันที่
              <span class="dotted-underline"> 25 กันยายน 2567</span> ซึ่งต่อไป
              ในสัญญานี้เรียกว่า "สํานักงาน" ฝ่ายหนึ่ง กับ นาย/นาง/นางสาว<span
                class="dotted-underline"
              >
                {{ personnel_temporary_govems.frist_names }}
              </span>

              อายุ<span class="dotted-underline"> {{ get_ageUser }} </span>ปี
              วัน/เดือน/ปี เกิด<span class="dotted-underline">
                {{
                  personnel_temporary_govems.brith_day +
                    "/" +
                    personnel_temporary_govems.brith_month +
                    "/" +
                    personnel_temporary_govems.brith_year
                }} </span
              > หมายเลขประจําตัวของผู้ถือบัตรประจําตัวประชาชน <span
                class="dotted-underline"
              >
                {{ personnel_temporary_govems.id_card }}
              </span>

              อยู่บ้านเลขที่
              <span class="dotted-underline">
                {{ personnel_temporary_govems.pt_homeid }} หมู่
                {{ personnel_temporary_govems.pt_moo }} </span
              >ถนน <span class="dotted-underline">
                {{ personnel_temporary_govems.pt_road || "-" }}
              </span>
              แขวง/ตําบล <span class="dotted-underline">
                {{ personnel_temporary_govems.district_name || "-" }}
              </span>

              เขต/อําเภอ <span class="dotted-underline">
                {{ personnel_temporary_govems.prefecture_name || "-" }} </span
              > จังหวัด <span class="dotted-underline">
                {{ personnel_temporary_govems.province_name || "-" }} </span
              > รหัสไปรษณีย์ <span class="dotted-underline">
                {{ personnel_temporary_govems.post || "-" }}
              </span>

              โทรศัพท์ <span class="dotted-underline">
                 {{ personnel_temporary_govems.tel_p || "-" }}
              </span>

              ระดับการศึกษา <span class="dotted-underline">{{
                personnel_temporary_govems.ed_abb_level || "-"
              }}</span
              > วุฒิการศึกษา <span class="dotted-underline">{{
                personnel_temporary_govems.ed_abb || "-"
              }} </span
              > สาขา <span class="dotted-underline">{{
                personnel_temporary_govems.ed_name || "-"
              }}</span
              > สถาบันที่จบ <span class="dotted-underline">{{
                personnel_temporary_govems.ed_university || "-"
              }} </span
              >วันที่เริ่มศึกษา-วันสำเร็จการศึกษา <span class="dotted-underline"
                > {{
                  formatDate(personnel_temporary_govems.ed_university_datebegin)
                }}
                -
                {{
                  formatDate(personnel_temporary_govems.ed_university_dateend)
                }}</span
              >
            </div>

            ซึ่งต่อไปในสัญญานี้เรียกว่า "พนักงานราชการ" อีกฝ่ายหนึ่ง
            ทั้งสองฝ่ายต่างได้ตกลงร่วมกันทําสัญญาจ้างไว้ต่อกัน ดังต่อไปนี้
          </div>

          <div class="text_j div-indent">
            ข้อ 1 สํานักงานตกลงจ้าง
            และพนักงานราชการตกลงรับจ้างทํางานให้แก่สํานักงานโดยเป็นพนักงานราชการ
            ดังต่อไปนี้
          </div>

          <div class="text_j div-indent">
            <v-icon size="25">mdi-checkbox-blank-outline</v-icon>
            พนักงานราชการพิเศษ ลักษณะงาน<span class="dotted-underline"
              >...................................................................</span
            >
          </div>

          <div class="text_j div-indent">
            <v-icon size="25">mdi-checkbox-outline</v-icon>
            พนักงานราชการทั่วไป กลุ่มงาน<span class="dotted-underline">...</span
            >บริหารทั่วไป<span class="dotted-underline">...</span>ตําแหน่ง<span
              class="dotted-underline"
              >................................................................</span
            >

            <div class="work-details">
              รหัสวิชา/รหัสตำแหน่ง<span class="dotted-underline"
                >................................</span
              >
              (ตําแหน่งเลขที่<span class="dotted-underline"
                >................................</span
              >)
            </div>
            <div>
              ปฏิบัติงานที่<span class="dotted-underline"
                >...................................................................</span
              >
            </div>
          </div>

          <div class="text_j div-indent">
            ข้อ 2
            พนักงานราชการมีหน้าที่รับผิดชอบภาระงานตามรายละเอียดที่สํานักงานกําหนดไว้ในเอกสารแนบท้ายสัญญาจ้าง
            และ
            ให้ถือว่าเอกสารแนบท้ายสัญญาจ้างดังกล่าวเป็นส่วนหนึ่งของสัญญาจ้างนี้
          </div>
          <div class="text_j div-indent">
            ในกรณีที่มีปัญหาว่างานใดเป็นหน้าที่การงานตามสัญญาจ้างนี้หรือไม่
            หรือกรณีที่มีข้อสงสัยเกี่ยวกับข้อความของสัญญาจ้างหรือข้อความในเอกสารแนบท้ายสัญญาจ้าง
            ให้สํานักงานเป็นผู้วินิจฉัยและพนักงานราชการจะต้องปฏิบัติตามคําวินิจฉัยนั้น
          </div>

          <div class="text_j div-indent">
            ข้อ 3 สํานักงานตกลงจ้างพนักงานราชการมีกําหนด<span
              class="dotted-underline"
              >.....</span
            >ปี<span class="dotted-underline">.......</span>เดือน<span
              class="dotted-underline"
              >.......</span
            >วัน เริ่มตั้งแต่วันที่<span class="dotted-underline">......</span
            >เดือน<span class="dotted-underline"
              >................................</span
            >พ.ศ.<span class="dotted-underline">...........</span>
            และสิ้นสุดในวันที่ 30 เดือน กันยายน พ.ศ. 2571
          </div>

          <div class="text_j div-indent">
            กําหนดระยะเวลาการมาปฏิบัติงานที่สํานักงานให้เป็นไปตามรายละเอียดแนบท้ายสัญญาจ้าง
            และให้ถือว่าเอกสารแนบท้าย สัญญาจ้างดังกล่าว
            เป็นส่วนหนึ่งของสัญญาจ้าง
          </div>

          <div class="text_j div-indent">
            ข้อ 4 สํานักงานตกลงจ่าย และพนักงานราชการตกลงรับค่าตอบแทนดังนี้
          </div>

          <div class="text_j div-indent">
            อัตราค่าตอบแทน เดือนละ<span class="dotted-underline"
              >................................</span
            >บาท และหรือค่าตอบแทนพิเศษ เงินช่วยค่าครองชีพชั่วคราว
            หรือค่าตอบแทนหรือ เงินพิเศษอื่น ๆ ที่มีสิทธิได้รับตามกฎหมาย
            กฎระเบียบ ประกาศ ฯลฯ ที่เกี่ยวข้อง
            ทั้งนี้พนักงานราชการต้องเป็นผู้รับผิดชอบในการเสียภาษีเงินได้
            โดยสํานักงานจะเป็นผู้หักไว้ ณ ที่จ่าย
          </div>

          <div class="div-indent text_j">
            ข้อ 5 พนักงานราชการอาจได้รับสิทธิประโยชน์อื่น
            ตามระเบียบสํานักนายกรัฐมนตรี ว่าด้วยพนักงานราชการ พ.ศ. 2547
            หรือตามที่คณะกรรมการหรือสํานักงานกําหนด
          </div>

          <div class="div-indent text_j">
            ข้อ 6
            สํานักงานจะทําการประเมินผลการปฏิบัติงานของพนักงานราชการตามหลักเกณฑ์และวิธีการที่สํานักงานกําหนด
            ผลการประเมินตามวรรคหนึ่งเป็นประการใด ให้ถือเป็นที่สุด
          </div>

          <div class="div-indent text_j">
            ข้อ 7 สัญญานี้สิ้นสุดลงเมื่อเข้ากรณีใดกรณีหนึ่ง ดังต่อไปนี้
          </div>
          <div class="div-indent-sec text_j">
            (1) เข้ากรณีใดกรณีหนึ่งตามที่กําหนดในข้อ 28
            ของระเบียบสํานักนายกรัฐมนตรี ว่าด้วยพนักงานราชการ พ.ศ. 2547
          </div>

          <div class="div-indent-sec text_j">
            (2) พนักงานราชการลาออกจากการปฏิบัติงานตามข้อ 29
            ของระเบียบสํานักนายกรัฐมนตรี ว่าด้วยพนักงานราชการ พ.ศ. 2547
          </div>
          <div class="div-indent-sec text_j">
            (3) มีการเลิกสัญญาจ้างตามข้อ 30
            ของระเบียบสํานักนายกรัฐมนตรีว่าด้วยพนักงานราชการ พ.ศ. 2547
          </div>

          <div class="div-indent-sec text_j">
            (4) เหตุอื่น ๆ ดังต่อไปนี้ 4.1)
            สํานักงานคณะกรรมการการอาชีวศึกษาหมดความจําเป็นตามภารกิจในการจ้าง
          </div>
          <div class="div-indent-sec text_j">
            (5) เหตุอื่น ๆ ตามที่สํานักงานประกาศกําหนด
          </div>
          <div style="text-align: right; margin-top: 20px;">
            ลงชื่อพนักงานราชการ<span class="dotted-underline"
              >................................................................</span
            >
          </div>
        </div>

        <!-- New Page -->
        <p style="page-break-before: always;">&nbsp;</p>
        <!-- 2 -->
        <div class="text-center">-2-</div>
        <div class="">
          <div class="div-indent text_j">
            ข้อ 8
            พนักงานราชการมีหน้าที่ต้องรักษาวินัยและยอมรับการลงโทษทางวินัยตามที่กําหนดในระเบียบสํานักนายกรัฐมนตรีว่าด้วยพนักงานราชการ
            พ.ศ. 2547 และหรือที่สํานักงานประกาศกําหนด
          </div>

          <div class="div-indent text_j">
            ข้อ 9 ในกรณีพนักงานราชการละทิ้ง งานก่อนครบกําหนดเวลาตามข้อ 3
            หรือปฏิบัติงานใด ๆ จนเป็นเหตุให้เกิดความเสียหาย แก่สํานักงาน
            ในระหว่างอายุสัญญา
            พนักงานราชการยินยอมชดใช้ค่าเสียหายให้สํานักงานทุกประการภายในกําหนดเวลาที่สํานักงานเรียกร้องให้ชดใช้
            และยินยอมให้สํานักงานหักค่าจ้างหรือเงินอื่นใดที่พนักงานราชการมีสิทธิได้รับจากสํานักงาน
            เป็นการชดใช้ค่าเสียหายได้ เว้นแต่ความเสียหายนั้นเกิดจากเหตุสุดวิสัย
          </div>

          <div class="div-indent text_j">
            ข้อ 10
            พนักงานราชการจะต้องปฏิบัติตามระเบียบสํานักนายกรัฐมนตรีว่าด้วยพนักงานราชการ
            พ.ศ.2547 ประกาศหรือมติของคณะกรรมการบริหารพนักงานราชการ
            ประกาศหรือคําสั่งของสํานักงานที่ออกตามระเบียบสํานักนายกรัฐมนตรีว่าด้วยพนักงานราชการ
            พ.ศ. 2547
          </div>

          <div class="div-indent text_j">
            ข้อ 11 พนักงานราชการจะต้องประพฤติ และปฏิบัติตามกฎหมาย ระเบียบ
            ข้อบังคับ และคําสั่งของทางราชการ
            ทั้งที่ได้ออกใช้บังคับแก่พนักงานราชการอยู่แล้วก่อนวันที่ลงนามในสัญญาจ้างนี้
            และที่จะออกใช้บังคับต่อไปในภายหลัง โดยพนักงานราชการยินยอมให้
            ถือว่ากฎหมาย ระเบียบ หรือคําสั่งต่าง ๆ ดังกล่าว
            เป็นส่วนหนึ่งของสัญญาจ้างนี้
          </div>

          <div class="div-indent text_j">
            ข้อ 12 พนักงานราชการต้องปฏิบัติงานให้กับสํานักงานตามที่ได้รับมอบหมาย
            ด้วยความซื่อสัตย์ สุจริต และตั้งใจปฏิบัติงาน
            อย่างเต็มกําลังความสามารถของตน โดยแสวงหาความรู้และทักษะเพิ่มเติม
            หรือกระทําการใด ๆ เพื่อให้ผลงานในหน้าที่มีคุณภาพดีขึ้น ทั้งนี้
            ต้องรักษาผลประโยชน์ และชื่อเสียงของราชการ
            และไม่เปิดเผยความลับหรือข้อมูลของทางราชการให้ผู้หนึ่งผู้ใดทราบ
            โดยมิได้รับอนุญาตจากผู้รับผิดชอบงานนั้น ๆ
          </div>

          <div class="div-indent text_j">
            ข้อ 13 ในระหว่างอายุสัญญาจ้างนี้
            หากพนักงานราชการปฏิบัติงานตามสัญญาจ้างแล้วก่อให้เกิดผลงานสร้างสรรค์ขึ้นใหม่
            ให้ลิขสิทธิ์ของผลงานดังกล่าวเป็นกรรมสิทธิ์ของสํานักงาน
          </div>

          <div class="div-indent text_j">
            ข้อ 14 พนักงานราชการจะต้องรับผิดต่อการละเมิดบทบัญญัติแห่งกฎหมาย
            หรือสิทธิใด ๆ ในสิทธิบัตร หรือลิขสิทธิ์ของบุคคลที่สาม
            ซึ่งพนักงานราชการนํามาใช้ในการปฏิบัติตามสัญญานี้
          </div>

          <div class="div-indent text_j">
            ข้อ 15 สิทธิ หน้าที่
            และความรับผิดของพนักงานราชการนอกเหนือจากที่กําหนดไว้ในสัญญาจ้างนี้
            ให้เป็นไปตามกฎหมาย ระเบียบข้อบังคับที่ทางราชการกําหนดไว้
          </div>

          <div class="text_j div-indent">
            สัญญานี้ทำขึ้นสองฉบับมีข้อความถูกต้องตรงกัน คู่สัญญาอ่าน ตรวจสอบ
            และเข้าใจข้อความในสัญญาโดยละเอียดแล้ว
            จึงลงลายมือชื่อไว้เป็นหลักฐานต่อหน้าพยาน ณ วัน เดือน ปี
            ดังกล่าวข้างต้น และต่างฝ่ายต่างเก็บรักษาไว้ฝ่ายละฉบับ
          </div>
          <br />
          <br />
          <br />
          <br />
          <table class="text_j" border="0" width="100%">
            <tr>
              <td width="50%"></td>
              <td class="text-center">
                (ลงชื่อ.........................................................สถาบัน
              </td>
            </tr>
            <tr>
              <td width="50%"></td>
              <td class="text-center">
                (...................................................................)
              </td>
            </tr>
            <tr>
              <td width="50%"></td>
              <td class="text-center">
                (ลงชื่อ).........................................................พนักงานราชการ
              </td>
            </tr>
            <tr>
              <td width="50%"></td>
              <td class="text-center">
                (...................................................................)
              </td>
            </tr>
            <tr>
              <td width="50%"></td>
              <td class="text-center">
                (ลงชื่อ).........................................................พยาน
              </td>
            </tr>
            <tr>
              <td width="50%"></td>
              <td class="text-center">
                (...................................................................)
              </td>
            </tr>
            <tr>
              <td width="50%"></td>
              <td class="text-center">
                (ลงชื่อ).........................................................พยาน
              </td>
            </tr>
            <tr>
              <td width="50%"></td>
              <td class="text-center">
                (...................................................................)
              </td>
            </tr>
          </table>

          <div style="text-align: right; margin-top: 20px;">
            ลงชื่อพนักงานราชการ<span class="dotted-underline"
              >................................................................</span
            >
          </div>
        </div>

        <!-- New Page -->
        <p style="page-break-before: always;">&nbsp;</p>
        <!-- 3 -->
        <div class="text-center">-3-</div>
        <div class="text-center text_j">เอกสารแนบท้ายสัญญาจ้าง</div>
        <div class="text-center text_j">_________________________________</div>

        <div class="text-center text_j">ผนวก ก.</div>
        <div class="subtitle bold">
          หน้าที่ความรับผิดชอบของพนักงานราชการ
        </div>

        <div class="div-indent text_j">
          1. พนักงานราชการพิเศษ (ให้ระบุขอบเขตของลักษณะการปฏิบัติงาน ระยะเวลา
          ผลผลิต หรือวิธีปฏิบัติงานกรณีอื่นที่แสดงให้เห็นผลสําเร็จของงาน)
        </div>

        <div class="text_j">
          <div v-for="n in 9" :key="n">
            ..............................................................................................................................................................................................................
          </div>
        </div>

        <div class="div-indent text_j">
          2. พนักงานราชการทั่วไป
          (ให้ระบุหน้าที่ความรับผิดชอบหรือผลผลิตตามระยะเวลา)
        </div>

        <div class="div-indent text_j">
          2.1
          มีหน้าที่และความรับผิดชอบตามรายละเอียดมาตรฐานทั่วไปของงานในตําแหน่งที่จ้างตามที่สํานักงานคณะกรรมการการอาชีวศึกษากําหนด
          โดยมีหน้าที่ความรับผิดชอบหลักในการปฏิบัติงานตามรายละเอียดในประกาศรับสมัครฯ
          ที่สอบขึ้นบัญชีรายชื่อ ผู้ผ่านการเลือกสรรไว้
          ทั้งนี้ให้รวมถึงกรณีที่จะกําหนดต่อไปด้วย
        </div>

        <div class="div-indent text_j">
          2.2
          มีหน้าที่และความรับผิดชอบตามที่สํานักงานคณะกรรมการการอาชีวศึกษา/สถาบันการอาชีวศึกษา/สถานศึกษา
          อาจมีคําสั่งมอบหมายให้พนักงานราชการปฏิบัติในภายหลังด้วย
        </div>

        <div class="div-indent text_j">
          2.3 ให้รวมถึงหน้าที่และความรับผิดชอบตามกรณีในหมายเหตุด้านล่างนี้ด้วย
        </div>

        <div class="text_j">
          <div v-for="n in 9" :key="n">
            ..............................................................................................................................................................................................................
          </div>
        </div>

        <div class="text_j div-indent">
          <div class="bold">
            หมายเหตุ 1.
            ในกรณีที่สํานักงานได้กําหนดรายละเอียดมาตรฐานทั่วไปของงานในตําแหน่งใดไว้แล้ว
            อาจกําหนดหน้าที่ความรับผิดชอบของพนักงานราชการให้ปฏิบัติตามที่สํานักงานกําหนดไว้สําหรับตําแหน่งนั้นก็ได้
            2. ในกรณีจําเป็นเพื่อประโยชน์ของทางราชการ
            สํานักงานอาจมีคําสั่งมอบหมายงานให้พนักงานราชการปฏิบัติเป็นพิเศษ
            นอกเหนือจากขอบเขตหน้าที่ความรับผิดชอบที่กําหนดไว้ได้
            โดยไม่ต้องแก้ไขสัญญา และพนักงานราชการยินยอมปฏิบัติ
            ตามคําสั่งของสํานักงาน
            โดยถือเป็นการกําหนดหน้าที่ความรับผิดชอบตามสัญญานี้
          </div>

          <div style="text-align: right; margin-top: 20px;">
            ลงชื่อพนักงานราชการ<span class="dotted-underline"
              >................................................................</span
            >
          </div>
        </div>

        <!-- New Page -->
        <p style="page-break-before: always;">&nbsp;</p>
        <!-- 4 -->
        <div class="text-center text_j">-4-</div>
        <div class="text-center text_j">เอกสารแนบท้ายสัญญาจ้าง</div>
        <div class="text-center text_j">_________________________________</div>

        <div class="text-center text_j">ผนวก ข.</div>
        <div class="mt-4">กําหนดระยะเวลาการมาปฏิบัติหน้าที่</div>

        <div class="div-indent text_j">
          1. พนักงานราชการพิเศษ
        </div>

        <div class="text_j div-indent">
          <v-icon size="25">mdi-checkbox-blank-outline</v-icon>
          ปฏิบัติงานตามเวลาการปฏิบัติงานราชการปกติ
        </div>

        <div class="text_j div-indent">
          <v-icon size="25">mdi-checkbox-blank-outline</v-icon>
          ปฏิบัติงานตามระยะเวลา ดังนี้
        </div>

        <div class="text_j">
          <div v-for="n in 3" :key="n">
            ..............................................................................................................................................................................................................
          </div>
        </div>

        <div class="text_j div-indent">
          <v-icon size="25">mdi-checkbox-blank-outline</v-icon>
          ปฏิบัติงานตามผลผลิตของงาน ดังนี้
        </div>

        <div class="text_j">
          <div v-for="n in 3" :key="n">
            ..............................................................................................................................................................................................................
          </div>
        </div>

        <div class="text_j div-indent">
          <v-icon size="25">mdi-checkbox-blank-outline</v-icon> อื่น ๆ
        </div>

        <div class="text_j">
          <div v-for="n in 3" :key="n">
            ..............................................................................................................................................................................................................
          </div>
        </div>

        <div class="div-indent text_j">
          2. พนักงานราชการทั่วไป
        </div>

        <div class="text_j div-indent">
          <v-icon size="25">mdi-checkbox-outline</v-icon>
          ปฏิบัติงานตามเวลาการปฏิบัติงานราชการปกติ
        </div>

        <div class="text_j div-indent">
          <v-icon size="25">mdi-checkbox-blank-outline</v-icon>
          ปฏิบัติงานตามระยะเวลา ดังนี้
        </div>

        <div class="text_j">
          <div v-for="n in 3" :key="n">
            ..............................................................................................................................................................................................................
          </div>
        </div>

        <div class="text_j div-indent">
          <v-icon size="25">mdi-checkbox-blank-outline</v-icon>
          ปฏิบัติงานตามผลผลิตของงาน ดังนี้
        </div>
        <div class="text_j">
          <div v-for="n in 3" :key="n">
            ..............................................................................................................................................................................................................
          </div>
        </div>
        <div class="text_j div-indent">
          <div class="text_j div-indent">
            <div class="bold">
              <v-icon size="25">mdi-checkbox-blank-outline</v-icon> อื่น ๆ
            </div>
          </div>
        </div>

        <div>
          <span class="dotted-underline">................</span
          >ให้รวมถึงหน้าที่และความรับผิดชอบตามกรณีในหมายเหตุด้านล่างนี้ด้วย
          ซึ่งรวมถึงกรณีที่หน่วยงาน<span class="dotted-underline"
            >................................................................</span
          >

          <span class="dotted-underline">................</span
          >และหรือผู้บังคับบัญชาเป็นผู้มีคําสั่งฯ ด้วย
          ซึ่งสั่งตามอํานาจหน้าที่โดยชอบด้วยกฎหมาย<span class="dotted-underline"
            >................................................</span
          >

          <span class="dotted-underline"
            >...................................................................</span
          >
        </div>

        <table width="100%" class="text_j">
          <tr>
            <td style="vertical-align: top;" width="10%">หมายเหตุ</td>
            <td>
              <div class="">
                ในกรณีที่มีความจําเป็นเพื่อประโยชน์ของทางราชการ
                สํานักงานอาจมีคําสั่งเปลี่ยนแปลงระยะเวลาการมาปฏิบัติหน้าที่หรือ
                มีคําสั่งให้ปฏิบัติหน้าที่เป็นอย่างอื่นได้ โดยไม่ต้องแก้ไขสัญญา
                และพนักงานราชการยินยอมปฏิบัติตามคําสั่งของสํานักงาน
                โดยถือเป็นการกําหนดระยะเวลาการมาปฏิบัติงานตามสัญญานี้
              </div>
            </td>
          </tr>
        </table>

        <div class="text_j div-indent">
          <div style="text-align: right; margin-top: 20px;">
            ลงชื่อพนักงานราชการ<span class="dotted-underline"
              >................................................................</span
            >
          </div>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
export default {
  name: "Report",
  data() {
    return {
      ApiKey: "HRvec2021",
      personnel_temporary_govems: [],
      period_college: [],
      conditons_transfer_success_govem: [],
      government_employee: [],
      years: ""
    };
  },
  async mounted() {
    await this.periodQuery();
    await this.conditons_transfer_success_govemQuery();
    await this.government_employeeQuery();
    await this.personnel_temporary_govemQuery();
  },
  computed: {
    pid() {
      return this.$route.query.pid;
    },
    date_today_cal() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      let yyyy = today.getFullYear();

      today = yyyy + "-" + mm + "-" + dd;
      return today;
    },

    get_ageUser() {
      let today = new Date(this.date_today_cal);
      let DOB = new Date(
        parseInt(this.personnel_temporary_govems.brith_year) -
          543 +
          "-" +
          this.personnel_temporary_govems.brith_month +
          "-" +
          this.personnel_temporary_govems.brith_day
      );
      let totalMonths =
        (today.getFullYear() - DOB.getFullYear()) * 12 +
        today.getMonth() -
        DOB.getMonth();
      totalMonths += today.getDay() < DOB.getDay() ? -1 : 0;
      let years = today.getFullYear() - DOB.getFullYear();
      if (DOB.getMonth() > today.getMonth()) years = years - 1;
      else if (DOB.getMonth() === today.getMonth())
        if (DOB.getDate() > today.getDate()) years = years - 1;

      let days;
      let months;

      if (DOB.getDate() > today.getDate()) {
        months = totalMonths % 12;
        if (months == 0) months = 11;
        let x = today.getMonth();
        switch (x) {
          case 1:
          case 3:
          case 5:
          case 7:
          case 8:
          case 10:
          case 12: {
            let a = DOB.getDate() - today.getDate();
            days = 31 - a;
            break;
          }
          default: {
            let a = DOB.getDate() - today.getDate();
            days = 30 - a;
            break;
          }
        }
      } else {
        days = today.getDate() - DOB.getDate();
        if (DOB.getMonth() === today.getMonth()) months = 0;
        else months = totalMonths % 12;
      }
      let age = years + " ปี";
      return age;
    }
  },
  methods: {
       formatDate(dateString) {
      if (!dateString) return '';
      return moment(dateString).add(543, 'years').format('D MMMM YYYY');
    },

    async periodQuery() {
      let result_period;
      result_period = await this.$http.post("period_college.php", {
        ApiKey: this.ApiKey,
        period_college_id: "80103"
      });
      this.period_college = result_period.data;
      if (this.period_college.period_college_enable != "1") {
        this.$router.push("/");
      }
      let years = parseInt(this.period_college.period_college_year) + 1;
      this.years = years;
    },

    async conditons_transfer_success_govemQuery() {
      let result = await this.$http.post(
        "conditons_transfer_success_govem.php",
        {
          ApiKey: this.ApiKey,
          ctsid_card: this.pid,
          ctstime_s: this.period_college.period_college_times,
          ctsyear_s: this.period_college.period_college_year
        }
      );
      this.conditons_transfer_success_govem = result.data;
      if (
        String(this.conditons_transfer_success_govem.ctsid_card).length < 12
      ) {
        this.$router.push("/");
      }
    },

    async government_employeeQuery() {
      let result = await this.$http.post("government_employee.php", {
        ApiKey: this.ApiKey,
        id_position_uniq: this.conditons_transfer_success_govem.ctsid_position
      });
      this.government_employee = result.data;
    },

    async personnel_temporary_govemQuery() {
      let result = await this.$http.post("personnel_temporary_govem.php", {
        ApiKey: this.ApiKey,
        id_card: this.pid
      });
      this.personnel_temporary_govems = result.data;
      ;
    },

    Export2Doc(element, filename) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-16'><title>Export HTML To Doc</title></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword"
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-16," +
        encodeURIComponent(html);

      // Specify file name
      filename = filename ? filename + ".doc" : "document.doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    }
  }
};
</script>

<style>
body {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16px;
  font-weight: 250;
}

.u {
  border-bottom: 1px dotted #000;
  text-decoration: none;
}
u {
  border-bottom: 1px dotted #000;
  text-decoration: none;
}

.dotted-underline {
  border-bottom: 1px dotted black;
  text-decoration: none; /* ปิดเส้นใต้แบบปกติ */
}

* {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}
p.indent {
  text-indent: 10px;
}
.div-indent {
  text-indent: 3em;
}

.div-indent-sec {
  text-indent: 4em;
}

.table,
.th,
.td {
  border-bottom: 0.5px solid black;
  border-top: 1px solid black;
  border-left: 1px solid black;
  border-right: 1px solid black;
  border-collapse: collapse;
}

.text_j {
  border-collapse: collapse;
  text-align: justify;
  text-justify: inter-word;
  line-height: 1;
}
.text_l {
  border-collapse: collapse;
  text-align: left;
  text-justify: inter-word;
  line-height: 1;
}

tfoot tr:hover {
  background-color: initial;
}

tbody tr:hover {
  background-color: inherit;
}

td,
th {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
}

tfoot td {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-weight: bold;
}

#verticaltext {
  writing-mode: tb-rl;
  filter: flipv fliph;
  -webkit-transform: rotate(-90deg);
  white-space: nowrap;
  display: block;
  overflow: hidden;
  padding: 0;
}

.page {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
  width: 21cm;
  min-height: 29.7cm;
  border: 1px #d3d3d3 solid;
  border-radius: 5px;
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  margin-top: 0cm;
  margin-right: auto;
  margin-bottom: 0cm;
  margin-left: auto;
  padding-top: 1cm;
  padding-right: 1cm;
  padding-bottom: 1cm;
  padding-left: 1cm;
}

.head {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 22pt;
  font-weight: bold;
  line-height: 1.5;
}

.regular12 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 14pt;
}

.regular16 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
}

.bold16 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
  font-weight: bold;
}

.blod12 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 14pt;
  font-weight: bold;
}

.blackRegula10 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 12pt;
}

.blackBold18 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 18pt;
  font-weight: bold;
}

.largerCheckbox {
  width: 30px;
  height: 30px;
  color: blue;
}
.td_line {
  border-bottom: 1pt dotted black;
}
/*.subpage {
      height: 247mm;
    }*/

.BlackBold10 {
  font-weight: bold;
}

#content {
  display: table;
}

#pageFooter {
  display: table-footer-group;
}

#pageFooter:after {
  counter-increment: page;
  content: counter(page);
}

@media print {
  .page {
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    padding-top: 1cm;
    padding-right: 1cm;
    padding-bottom: 1cm;
    padding-left: 1.5cm;
  }

  .head {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 18pt;
    font-weight: bold;
  }

  .regular12 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 16pt;
  }

  .regular16 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 16pt;
  }

  .bold16 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 16pt;
    font-weight: bold;
  }

  .blod12 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 16pt;
    font-weight: bold;
  }

  .blackRegula10 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 14pt;
  }

  .blackBold18 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 18pt;
    font-weight: bold;
  }

  /* .head {
        font-size: 18px;
        font-weight: bold;
      }
      .regular12 {
        font-size: 12px;
      }
      .blod12 {
        font-size: 12px;
        font-weight: bold;
      }
      .blackRegula8 {
        font-size: 8px;
      } */
  .noprint {
    display: none;
  }

  .gap-10 {
    width: 100%;
    height: 10px;
  }
  .gap-20 {
    width: 100%;
    height: 20px;
  }
  .gap-30 {
    width: 100%;
    height: 30px;
  }
}
</style>
